import { render, staticRenderFns } from "./RegisteredLegalDocument.vue?vue&type=template&id=2ea33710&scoped=true&"
import script from "./RegisteredLegalDocument.vue?vue&type=script&lang=js&"
export * from "./RegisteredLegalDocument.vue?vue&type=script&lang=js&"
import style0 from "./RegisteredLegalDocument.vue?vue&type=style&index=0&id=2ea33710&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea33710",
  null
  
)

export default component.exports